var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('edit-profile-form')],1),_c('div',{staticClass:"col-md-4"},[_c('user-card')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }